import { env as appEnv } from './env';

export const isSupabase =
  (appEnv?.DATA_SOURCE ?? import.meta.env?.VITE_DATA_SOURCE ?? "mock") ===
  "supabase";
